import type { ReactNode } from "react";
import { NotificationCenter } from "@/components/portal/NotificationCenter";
import { AccountMenu, AccountMenuContext } from "@/components/portal/AccountMenu";

type AuthenticatedHeaderProps = {
  userEmail: string;
  userName?: string;
  context?: AccountMenuContext;
  roleLabel?: string;
  onExitImpersonation?: () => void;
  showLiveScan?: boolean;
  showPromotions?: boolean;
  sandboxMode?: boolean;
  onToggleSandbox?: (enabled: boolean) => void;
  toggingSandbox?: boolean;
  leftSlot: ReactNode;
  centerSlot?: ReactNode;
  rightSlot?: ReactNode;
};

export function AuthenticatedHeader({
  userEmail,
  userName,
  context = "customer",
  roleLabel,
  onExitImpersonation,
  showLiveScan = false,
  showPromotions = false,
  sandboxMode,
  onToggleSandbox,
  toggingSandbox,
  leftSlot,
  centerSlot,
  rightSlot,
}: AuthenticatedHeaderProps) {
  return (
    <header className="relative z-30 border-b border-border/50 bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">{leftSlot}</div>
        {centerSlot && (
          <div className="hidden sm:flex items-center gap-2 flex-wrap justify-end">
            {centerSlot}
          </div>
        )}
        <div className="flex items-center gap-2">
          {rightSlot}
          <NotificationCenter />
          <AccountMenu
            userEmail={userEmail}
            userName={userName}
            context={context}
            roleLabel={roleLabel}
            onExitImpersonation={onExitImpersonation}
            showLiveScan={showLiveScan}
            showPromotions={showPromotions}
            sandboxMode={sandboxMode}
            onToggleSandbox={onToggleSandbox}
            toggingSandbox={toggingSandbox}
          />
        </div>
      </div>
    </header>
  );
}
